// @flow
import { APICore } from './apiCore';
import config from '../../config';
import axios from 'axios';

const api = new APICore();


// ***ALTERNATE FORMATTING OF THE HELPER FILE -- CONSIDER USING***
// const GMAIL = {
//   connect: () => api.get('/v1/gmail/connect'),
//   sendEmail: (data) => api.post('/v1/gmail/send', data),
//   disconnect: () => api.post('/v1/gmail/disconnect'),
//   // add more Gmail-related methods here
// };

// export default GMAIL;

// src/api/gmail.js or src/api/gmail.ts

/**
 * Check Gmail connection status
 * @param {*} params
 * @returns
 */
export function checkGmailStatus(params) {
  return axios.post(`${config.server.api}/v1/gmail/status`, { account: params.account }, {
    headers: {
      Authorization: `${params.headers.Authorization}`,
    },
  });
}



/**
 * Connect Gmail (starts the OAuth flow)
 * @param {*} params
 * @returns
 */
export function connectGmail({ userId, address }: { userId: string; address: string }) {
  const baseUrl = `${config.server.api}/v1/gmail/login`;
  const queryData = encodeURIComponent(JSON.stringify({ userId, address }));
  return api.get(`${baseUrl}?data=${queryData}`);
}


/**
 * Send email via Gmail
 * @param {*} data
 * @returns
 */
export function sendGmailEmail(data: any): any {
    const baseUrl = `${config.server.api}/v1/gmail/send`;
    return api.create(baseUrl, data);
}

/**
 * Gmail Callback
 * @param {{ code: string, state: string }} data
 * @returns {Promise<any>}
 */
/**
 * Gmail Callback
 * @param {{ code: string, state: string }} data
 * @returns {Promise<any>}
 */
export function gmailCallback(data: { code: string; state: string }): any {
  const baseUrl = `${config.server.api}/v1/gmail/oauth/callback`;

  return api.get(baseUrl, {
    // method: 'GET',
    params: data, // attaches ?code=...&state=... to the URL
  });
}

/**
 * Disconnect Gmail
 * @param {*} params
 * @returns
 */
export function disconnectGmail(params: any): any {
    const baseUrl = `${config.server.api}/v1/gmail/disconnect`;
    return api.create(baseUrl, params);
  }
  